// generated from 1_108 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastReceivedSmsCampaignFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_received_sms_campaign_filter"),
  comparison_key: z.enum([
    "6", // 687 (62.00%)
    "12", // 212 (19.13%)
    "4", // 165 (14.89%)
    "3", // 33 (2.98%)
    "5", // 11 (0.99%)
  ]),
  display_name: z.string(),
  // undefined: 593 (53.52%), defined 515 (46.48%)
  raw_value: z
    .union([
      // number samples: 316 (61.36%)
      // integer: 194 (61.39%)
      // avg: 20.86, min: 0.041666666666666664, max: 364
      z.number().nonnegative(),
      // string samples: 199 (38.64%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 852 (76.90%)
    // integer: 693 (81.34%)
    // avg: 9.25, min: 0, max: 364
    z.number().min(0),
    // string samples: 256 (23.10%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
